import PropertyClassicContainer from "../../../components/property/detail/PropertyClassic";

const PropertyClassic = () => {
  return <PropertyClassicContainer />;
};

export default PropertyClassic;
